import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { intlMixin } from '@/i18n/intl-i18n';
export default {
  name: 'IntlPagination',
  mixins: [intlMixin],
  props: {
    page: {
      type: Number,
      required: true
    },
    size: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    pageSizes: {
      type: Array,
      default: function _default() {
        return [10, 12];
      }
    }
  },
  computed: {
    totalPages: function totalPages() {
      return Math.max(1, Math.ceil(this.total / this.size));
    }
  },
  methods: {
    go: function go(nextPage) {
      if (nextPage < 1 || nextPage > this.totalPages || nextPage === this.page) return;
      this.$emit('change', {
        page: nextPage,
        size: this.size
      });
    },
    changeSize: function changeSize(value) {
      var nextSize = Number(value);
      if (!nextSize || nextSize === this.size) return;
      var nextPage = Math.min(this.page, Math.max(1, Math.ceil(this.total / nextSize)));
      this.$emit('change', {
        page: nextPage,
        size: nextSize
      });
    }
  }
};